import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableRow from '@material-ui/core/TableRow'
import TablePagination from '@material-ui/core/TablePagination'
import Paper from '@material-ui/core/Paper'
import { compose } from 'recompose'
import { connect } from 'react-redux'

import { TableHead, TableTitle } from '../../common'

import * as Strings from './strings'
import * as Functions from '../../../helpers/Functions'

const ROWS = [
  {
    id: 'date',
    label: Strings.default.DATE,
    numeric: false,
    sortType: 'string'
  },
  {
    id: 'start',
    label: Strings.default.TIME,
    numeric: false,
    sortType: 'start'
  },
  {
    id: 'apartment',
    label: Strings.default.BOOKED_BY,
    numeric: false,
    sortType: 'apartment'
  },
  {
    id: 'status',
    label: Strings.default.STATUS,
    numeric: false,
    sortType: 'status'
  }
]

class PastBookingsTable extends Component {
  state = {
    page: 0,
    rowsPerPage: 5,
    orderBy: 'date',
    order: 'desc',
    sortType: 'string'
  }

  getTime(timeId) {
    const { system } = this.props
    const times = system.times

    for (let i = 0; i < times.length; i++) {
      if (times[i].id.toString() === timeId.toString()) {
        return times[i].start + '-' + times[i].end
      }
    }

    return Strings.default.NOT_AVAILABLE
  }

  getApartment(apartmentId) {
    const { data } = this.props
    const apartments = data.community.apartments

    for (let i = 0; i < apartments.length; i++) {
      if (apartments[i].id.toString() === apartmentId.toString()) {
        return Strings.default.APARTMENT + ' ' + apartments[i].number
      }
    }

    return Strings.default.NOT_AVAILABLE
  }

  getStatus(status) {
    if (status === 'unbooked') {
      return Strings.default.UNBOOKED
    }

    return ''
  }

  desc(a, b, orderBy, sortType) {
    if (sortType === 'start') {
      const aTime = this.getTime(a.bookableTimeId)
      const bTime = this.getTime(b.bookableTimeId)

      if (
        aTime !== Strings.default.NOT_AVAILABLE &&
        bTime !== Strings.default.NOT_AVAILABLE
      ) {
        const aStart = aTime.split('-')[0]
        const bStart = bTime.split('-')[0]
        const aMinutes = aStart.split(':')[0] * 60 + aStart.split(':')[1]
        const bMinutes = bStart.split(':')[0] * 60 + bStart.split(':')[1]

        return aMinutes - bMinutes
      }

      if (aTime === Strings.default.NOT_AVAILABLE) {
        return -1
      }

      return 1
    }

    if (sortType === 'apartment') {
      const aApartment = this.getApartment(a.apartmentId)
      const bApartment = this.getApartment(b.apartmentId)

      if (bApartment < aApartment) {
        return -1
      } else if (bApartment > aApartment) {
        return 1
      }

      return 0
    }

    if (b[orderBy] < a[orderBy]) {
      return -1
    } else if (b[orderBy] > a[orderBy]) {
      return 1
    }

    return 0
  }

  stableSort(array, cmp) {
    const stabilizedThis = array.map((el, index) => [el, index])

    stabilizedThis.sort((a, b) => {
      const order = cmp(a[0], b[0])

      if (order !== 0) {
        return order
      }

      return a[1] - b[1]
    })

    return stabilizedThis.map(el => el[0])
  }

  getSorting(order, orderBy, sortType) {
    return order === 'desc'
      ? (a, b) => this.desc(a, b, orderBy, sortType)
      : (a, b) => -this.desc(a, b, orderBy, sortType)
  }

  render() {
    const { classes, system } = this.props
    const { page, rowsPerPage, orderBy, order, sortType } = this.state
    const startIndex = page * rowsPerPage
    const bookings = system.bookings

    return (
      <Paper className={classes.root}>
        <TableTitle
          classes={classes}
          header={
            Strings.default.BOOKINGS_HISTORY_FOR +
            ' ' +
            system.name.toLowerCase()
          }
          addIcon={false}
        />
        <Table className={classes.table}>
          <TableHead
            rows={ROWS}
            order={order}
            orderBy={orderBy}
            sortOn={(newOrderBy, newOrder, newSortType) =>
              this.setState({
                orderBy: newOrderBy,
                order: newOrder,
                sortType: newSortType
              })
            }
            extraColumn={false}
          />
          <TableBody>
            {this.stableSort(
              bookings,
              this.getSorting(order, orderBy, sortType)
            )
              .slice(startIndex, rowsPerPage + startIndex)
              .map(booking => {
                return (
                  <TableRow key={booking.id} className={classes.row}>
                    <TableCell>
                      {Functions.parseDate(new Date(booking.date))}
                    </TableCell>
                    <TableCell>
                      {this.getTime(booking.bookableTimeId)}
                    </TableCell>
                    <TableCell>
                      {this.getApartment(booking.apartmentId)}
                    </TableCell>
                    <TableCell>{this.getStatus(booking.status)}</TableCell>
                  </TableRow>
                )
              })}
          </TableBody>
        </Table>
        <TablePagination
          component={'div'}
          count={bookings.length}
          rowsPerPage={rowsPerPage}
          page={page}
          backIconButtonProps={{
            'aria-label': 'Previous Page'
          }}
          nextIconButtonProps={{
            'aria-label': 'Next Page'
          }}
          labelRowsPerPage={'Rader per sida:'}
          labelDisplayedRows={({ from, to, count }) =>
            `${from}-${to} av ${count}`
          }
          onChangePage={(event, page) => this.setState({ page })}
          onChangeRowsPerPage={event =>
            this.setState({ rowsPerPage: event.target.value })
          }
          rowsPerPageOptions={[5, 10, 25, 50, 100]}
        />
      </Paper>
    )
  }
}

const Styles = {
  root: {
    width: '100%',
    overflowX: 'auto',
    marginBottom: 25
  },
  table: {
    minWidth: 700
  },
  row: {
    '&:nth-of-type(odd)': {
      backgroundColor: '#fafafa'
    }
  }
}

PastBookingsTable.propTypes = {
  classes: PropTypes.object.isRequired
}

function mapStateToProps({ data }) {
  return { data }
}

export default compose(
  withStyles(Styles),
  connect(mapStateToProps, null)
)(PastBookingsTable)



// WEBPACK FOOTER //
// ./src/components/containers/PastBookingsTable/index.js